module.exports = __webpack_public_path__ + "icons.acf3dcb7ff752b5296ca.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/styles/semantic/themes/default/assets/fonts/icons.svg
// module id = ../../../../../src/styles/semantic/themes/default/assets/fonts/icons.svg
// module chunks = styles